import { useEffect, useRef, useState } from "react";
import { initConnection } from "@/api/connection";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GenericErrorMessage } from "@/components/GenericErrorMessage/GenericErrorMessage";

export const QontoCallbackPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasRun = useRef(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");
    const storedState = sessionStorage.getItem("qonto_oauth_state");

    if (!code || !state || !storedState) {
      setErrorMessage(
        t("pages.integrations.connections.qonto.missingParamsError"),
      );
      return;
    }

    if (state !== storedState) {
      setErrorMessage(t("pages.integrations.connections.qonto.invalidStateError"));
      return;
    }

    initConnection({
      provider: "QONTO",
      code,
    })
      .then(() => {
        navigate("/integrations");
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error("Error processing OAuth callback:", error);
        setErrorMessage(t("pages.integrations.connections.qonto.oauthError"));
      });
    sessionStorage.removeItem("qonto_oauth_state");
  }, [navigate, t]);

  return (
    <div className="callback-container">
      <h1>{t("pages.integrations.connections.qonto.callbackTitle")}</h1>
      <p>{t("pages.integrations.connections.qonto.callbackSubtitle")}</p>
      {errorMessage ? (
        <>
          <p>{errorMessage}</p>
          <GenericErrorMessage />
        </>
      ) : null}
    </div>
  );
};

